import React, { useState, useRef } from 'react';
import { useMobile } from '../../../../hooks/useMobile';
import { formatDateForDb } from '../../../../utils';
import { KeyboardDatePicker } from '@material-ui/pickers';
import { stage as stageEnum, isLinesOnboardingPage } from '../../../../utils';
import moment, { Moment } from 'moment';
import messages from '../../../../messages';
import makeStyles from '@material-ui/core/styles/makeStyles';
import TextField from '@material-ui/core/TextField';
import StageDateLogo from './StageDateLogo';

const useStyles = makeStyles((theme: any) => ({
  date: {
    marginTop: theme.spacing(
      isLinesOnboardingPage(window.location.pathname) ? 0.4 : 0.25,
    ),
    marginBottom: theme.spacing(0.5),
    '& .MuiInput-underline.Mui-disabled:before': { borderBottomStyle: 'solid' },
    '& .MuiInputBase-input': {
      textAlign: 'center',
      marginLeft: -theme.spacing(1),
      cursor: 'pointer',
      color: theme.palette.brand.greenDark,
      fontWeight: 700,
      paddingBottom: 4,
      fontSize: 12,
    },
    '& .MuiIconButton-root': { padding: 0 },
    '& .MuiSvgIcon-root': {
      width: theme.spacing(2),
      color: theme.palette.grey[800],
    },
  },
  mobileDate: {
    margin: 0,
    '& .MuiInputBase-input': {
      textAlign: 'center',
      cursor: 'pointer',
      color: theme.palette.brand.greenDark,
    },
  },
}));

export default function StageDateEdit({
  stage,
  stockOnHand = false,
  handleStageUpdate,
  addOrDeleteError,
  setAutoSave = (arg) => {},
}) {
  const classes = useStyles();
  const mobile = useMobile('sm');
  const [anchorEl, setAnchorEl] = useState(null);
  const [openDatePicker, setOpenDatePicker] = useState(false);
  const [error, setError] = useState(false);
  const fieldRef = useRef();
  const date = stage.needsDateChange ? null : moment(stage.start);
  validateDate(date, false);

  function validateDate(date: Moment, markFieldRedOnErr: boolean = true) {
    const isOnboarding = isLinesOnboardingPage(window.location.pathname);
    const isStockOnHand = stage.name === stageEnum.sellingStart.value;
    if (isOnboarding && isStockOnHand) return;
    // IN THIS CASE, THERE IS A DIALOG FOR STOCK ON HAND
    const errKey = 'stage.' + stage.id + '.date';
    if (date === undefined || date === null || !moment(date).isValid()) {
      markFieldRedOnErr && setError(true);
      addOrDeleteError(
        true,
        errKey,
        messages.lines.lineEditErrors.stageDateValidDate,
      );
    } else if (!isStockOnHand && moment().subtract(1, 'day') > moment(date)) {
      markFieldRedOnErr && setError(true);
      addOrDeleteError(
        true,
        errKey,
        messages.lines.lineEditErrors.stageDateFutureDate,
      );
    } else {
      markFieldRedOnErr && setError(false);
      addOrDeleteError(false, errKey);
    }
    if (!markFieldRedOnErr) {
      markFieldRedOnErr && setError(false);
    }
  }

  function handleStageDateChange(event) {
    const date = moment(event);
    validateDate(date);
    if (date.isValid()) {
      handleStageUpdate(stage.id, 'start', formatDateForDb(date));
    }
  }

  function handleOpenDatePicker() {
    setAutoSave(false);
    setDatePickerOpen();
  }

  function handleCloseDatePicker() {
    setAutoSave(true);
    setDatePickerOpen();
  }

  function setDatePickerOpen() {
    setAnchorEl(fieldRef?.current);
    setOpenDatePicker(!openDatePicker);
  }
  const TextFieldComponent = (props) => {
    return <TextField {...props} disabled={true} />;
  };

  return (
    <>
      <div ref={fieldRef} />
      <KeyboardDatePicker
        className={mobile ? classes.mobileDate : classes.date}
        label={mobile ? 'Date expected' : null}
        inputVariant={mobile ? 'outlined' : 'standard'}
        PopoverProps={{
          anchorEl,
          anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
        }}
        initialFocusedDate={moment(stage?.start)}
        open={openDatePicker}
        error={error}
        helperText={null}
        onClick={handleOpenDatePicker}
        onClose={handleCloseDatePicker}
        onChange={handleStageDateChange}
        disableToolbar
        disablePast={stage.name !== stageEnum.sellingStart.value}
        autoOk
        variant="inline"
        format="MMM dd"
        margin={mobile && stockOnHand ? 'dense' : 'normal'}
        value={date}
        keyboardIcon={<StageDateLogo />}
        InputAdornmentProps={{ position: 'start' }}
        TextFieldComponent={TextFieldComponent}
      />
    </>
  );
}
